import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";

// 블랙 대시보드 플러그인 로드 (사이드바, 알림 등을 주입함)
import BlackDashboard from "./plugins/blackDashboard";

// 글로벌 디자인 시스템
import "@/assets/css/jeil-global.css";

// PWA 서비스워커 등록 (새 배포 시 자동 업데이트/새로고침 처리 포함)
import "./registerServiceWorker";

Vue.use(BlackDashboard);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");